import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Btn, P, Spinner } from "../../AbstractElements";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Card,
  CardBody,
} from "reactstrap";
import { toast } from "react-toastify";

const ForgetPassword = () => {
  const [toggleMethod, setToggleMethod] = useState(true); // true for email, false for phone
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  
  const Data = [
    {
      id: 2,
      heading: "Loader 3",
      spinnerClass: "loader-3",
    },
  ];
  
  const handleSendEmail = (e) => {

    e.preventDefault();
    setLoader(true);

    axios.post(`${process.env.REACT_APP_API_BASE_URL}/users/forget-password`, { email })
      .then(response => {
      console.log("🚀 ~ handleSendEmail ~ response:", response)

        if (response.status === 200) {
          toast.success("Successfully logged in!..");

          setLoader(false);

          navigate(`/verify-otp?email=${email}`, { state: { method: 'email', value: email, userId: response?.data?.userId } });
        }
      })
      .catch(error => {
        toast.error("User not found!..");
        setLoader(false);

      });
  };

  const handleSendPhone = (e) => {
    navigate("/verify-otp");
    e.preventDefault();
    // axios.post(`${process.env.REACT_APP_API_BASE_URL}/users/forgot-password/request-otp`, { phone })
    //   .then(response => {
    //     if (response.data.statusCode === 200) {
    //       navigate('/verify-otp', { state: { method: 'phone', value: phone } });
    //     } else {
    //       alert("Error sending OTP to phone");
    //     }
    //   })
    //   .catch(error => {
    //     alert("Error sending OTP to phone");
    //   });
  };

  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
      <Row className="w-100 justify-content-center">
        <Col md="6" lg="4">
          <Card className="mb-4" style={{ height: "400px" }}> {/* Increase card height */}
            <CardBody>
              <div className="login-main">
                <Link
                  to="/"
                  className="btn btn-link position-absolute"
                  style={{
                    font: "12px",
                    top: "10px",
                    left: "10px",
                    color: "black",
                    fontWeight: "bold",
                    textDecoration: "none",
                  }}
                >
                  &larr; Forget Password
                </Link>
                <Form className="theme-form login-form">
                  {toggleMethod ? (
                    <>
                      <FormGroup>
                        <Label style={{ color: "grey", margin: "40px 0px 60px" }}>

                          Enter the email address associated with the account.
                        </Label>
                        <Input
                          className="form-control"
                          type="email"
                          // value={email}
                          placeholder="Email"
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </FormGroup>
                    </>
                  ) : (
                    <>
                      <FormGroup>

                        <Label style={{ color: "grey", margin: "40px 0px 60px" }}>
                          Enter the phone number associated with the account.

                        </Label>
                        <Input
                          className="form-control"
                          type="tel"
                          // value={phone}
                          placeholder="Phone no."
                          onChange={(e) => setPhone(e.target.value)}
                          required
                        />
                      </FormGroup>
                    </>
                  )}

                  {/* <Link
                    onClick={(e) => {
                      e.preventDefault();
                      setToggleMethod(!toggleMethod);
                    }}
                    to={`/forgot-password`}
                    style={{
                      marginLeft: "5px",
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    Use {toggleMethod ? "use Phone no." : "use Email"}
                  </Link> */}
                  {loader && (
                    <div className="loader-box">
                      <Spinner
                        attrSpinner={{ className: Data[0].spinnerClass }}
                      />
                    </div>
                  )}
                  <button
                    className="btn btn-custom w-100 mt-5"
                    onClick={
                      toggleMethod === "use Phone no."
                        ? handleSendPhone
                        : handleSendEmail
                    }
                    disabled={loader}
                    style={{
                      backgroundColor: "#000",
                      borderRadius: "18px",
                      border: "none",
                      color: "#fff",
                      padding: "10px 20px",
                      marginTop: "40px  !important" // Adjust marginTop here to move the button down
                    }}
                  >

                    Continue
                  </button>
                </Form>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgetPassword;